<ng-container *ngIf="parentFolder">
  <apex-autocomplete-picker
    [params]="{ ObjectId: convertToNumber() }"
    [multiple]="false"
    type="ObjectField"
    (optionAdd)="updateField($event)"
    (optionRemoved)="updateField(null)"
    [label]="'Discipline' | translate">
  </apex-autocomplete-picker>
</ng-container>

<ng-container *ngIf="field">
  <div class="df c mat-elevation-z2">
    <div class="ap df c f1">
      <div class="df">
        <h2 class="rmv f1">
          {{ field.fullName }}
        </h2>

        <button
          color="warn"
          (click)="remove()"
          mat-raised-button>
          <T str="Remove"></T>
        </button>
      </div>

      <div class="amts mat-caption">{{ field.description }}</div>
      <div *ngIf="field.Contractors.length > 0; else noContractors"><T str="Contractors"></T></div>
      <div
        class="display-grid-cards card-width-200 auto-fit amv"
        *ngFor="let user of field.Contractors">
        <div class="df ac justify-space-between gap">
          <div class="f1">{{ user.name }} ({{ user.Customer?.name }})</div>
        </div>
      </div>
    </div>
    <div>
      <div class="df ac amrs jfe">
        <apex-color-picker [(ngModel)]="field.Field.color"></apex-color-picker>
        <button
          mat-icon-button
          [disabled]="!field.Contractors?.length"
          [matMenuTriggerFor]="contractorsMenu"
          [matMenuTriggerData]="{ field: field.Contractors }"
          (click)="$event.stopPropagation(); $event.preventDefault()"
          (mousedown)="$event.stopPropagation()">
          <mat-icon
            [matBadge]="field.Contractors?.length"
            [matBadgeHidden]="!field.Contractors?.length">
            person
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!field">
  <T str="No field selected"></T>
</ng-container>

<mat-menu #contractorsMenu="matMenu">
  <ng-template
    matMenuContent
    let-f="field">
    <div
      mat-menu-item
      *ngFor="let user of f">
      <div class="df ac justify-space-between gap">
        <div class="f1">{{ user.name }} ({{ user.Customer?.name }})</div>
      </div>
    </div>
  </ng-template>
</mat-menu>

<ng-template #noContractors>
  <T str="No contractors found"></T>
</ng-template>
